export var getNavigator = function getNavigator() {
  return typeof window !== 'undefined' && (window.navigator || navigator);
};
export var isClient = function isClient() {
  return typeof window !== 'undefined';
};
/* prettier-ignore */
// @ts-expect-error expected IE11 definition
// eslint-ignore-next-line

export var isIE = function isIE() {
  return (
    /*@cc_on!@*/
    false || !!document.documentMode
  );
};
export var hasTouchScreen = function hasTouchScreen() {
  return typeof window !== 'undefined' && 'ontouchstart' in window || typeof navigator !== 'undefined' && navigator.msMaxTouchPoints;
};